<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" :id='type+"modal"' data-backdrop="static" tabindex="-1"
         role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content border-0">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">{{modalTitle}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-light text-dark">
            <!--On appelle le formulaire demandé en paramètre du modal-->
            <EmailForm v-if="type==='register' || type==='recovery'" :type="type">
            </EmailForm>
            <p v-else>Unknown</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmailForm from './form/EmailForm.vue';

export default {
  name: 'Modal',
  components: { EmailForm },
  methods: {},
  // Paramètres du modal
  props: {
    type: String,
    btnText: String,
    modalTitle: String,
  },
};
</script>
